import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import styled from 'styled-components'
import { Button } from 'reactstrap'
import { FiFilePlus } from 'react-icons/fi'

import { SummaryRow } from './summary-row'
import { TitleRow } from './title-row'
import { InputRow } from './input-row'

import { CopyCostModal } from '../copy-cost-modal'
import { ConfirmSaveForm } from '../../../form'
import { FONTS } from '../../../../../constants'

const fallbackNull = (number) => (number === 'NaN' || number === Infinity || !number ? '0.00' : number)

export const TabPaneOtherService = forwardRef((props, ref) => {
  const root = document.getElementById('root')
  const [showCopyModal, setShowCopyModal] = useState({ show: false })
  const [showConfirmSave, setShowConfirmSave] = useState(false)
  const [vendors, setVendors] = useState([])
  const { isEdit, setIsEdit, rSelected, projectByID, editProjectInformation } = props

  const presale_snapshot = projectByID && projectByID.presale_snapshot ? projectByID.presale_snapshot.snapshot : null
  const isPresale = presale_snapshot && rSelected === 1
  const isImplementing = projectByID && projectByID.project_status === 'IMPLEMENTING'

  const totalCost = isPresale ? fallbackNull(presale_snapshot.$total_vendors_cost) : fallbackNull(projectByID.$total_vendors_cost)
  const totalPrice = isPresale ? fallbackNull(presale_snapshot.$total_vendors_price) : fallbackNull(projectByID.$total_vendors_price)
  const totalMargin = isPresale ? fallbackNull(presale_snapshot.$total_vendors_margin) : fallbackNull(projectByID.$total_vendors_margin)

  useEffect(() => {
    if (projectByID && projectByID.vendors) {
      if (!isPresale) {
        setVendors([...projectByID.vendors])
      } else if (presale_snapshot.vendors) {
        setVendors([...presale_snapshot.vendors])
      }
    }
  }, [projectByID, rSelected])

  useEffect(() => {
    if (isEdit) {
      root.scrollTop = root.scrollHeight - root.clientHeight
    }
  }, [vendors.length])

  useImperativeHandle(ref, () => ({
    editOtherService() {
      setShowConfirmSave(!showConfirmSave)
    },
  }))

  const handleClickAdd = () => {
    setVendors(
      [
        ...vendors,
        {
          sub_project_code: '',
          product_id: '',
          description: '',
          delivery_date: '',
          credit_term: '15',
          cost: 0,
          price: 0,
        },
      ]
    )
  }

  const handleChangeDate = (e, id) => {
    const newVendors = [...vendors]
    const vendor = { ...newVendors[id] }
    vendor.delivery_date = e || ''
    newVendors[id] = vendor
    setVendors(newVendors)
  }

  const handleChangeInput = (e, id) => {
    const newVendors = [...vendors]
    const vendor = { ...newVendors[id] }
    const field = e.target.name
    if (field === 'price' || field === 'cost') {
      vendor[field] = parseFloat(e.target.value.replace(/,/g, ''))
    } else {
      vendor[field] = e.target.value
    }
    newVendors[id] = vendor
    setVendors(newVendors)
  }

  const handleChangeSelect = (e, id, name) => {
    const newVendors = [...vendors]
    const vendor = { ...newVendors[id] }
    vendor[name] = e.value
    newVendors[id] = vendor
    setVendors(newVendors)
  }

  const confirmEditVendorCost = () => {
    const payload = { ...projectByID }
    delete payload.project_type
    delete payload.created
    delete payload.project_approve_status
    delete payload.created_by
    delete payload.project_number
    delete payload.__v
    delete payload.project_status
    delete payload._id
    delete payload.updated_by
    payload.vendors = [...vendors]
    editProjectInformation(payload)
    setShowConfirmSave(false)
    setIsEdit(false)
  }

  const copyRow = (id) => {
    const newVendors = [...vendors, vendors[id]]
    setVendors(newVendors)
  }

  const copyCost = () => {
    const numberOfCopies = document.getElementById('numberOfCopies')
    const id = showCopyModal.id
    const newVendors = [...vendors, ...Array(+numberOfCopies.value).fill(vendors[id])]
    setVendors(newVendors)
    setShowCopyModal({ show: false })
  }

  const deleteRow = (id) => {
    const newVendors = [...vendors]
    newVendors.splice(id, 1)
    setVendors(newVendors)
  }

  return (
    <Root>
      <ConfirmSaveForm
        open={ showConfirmSave }
        toggle={ () => setShowConfirmSave(!showConfirmSave) }
        confirmSave={ confirmEditVendorCost }
      />
      <CopyCostModal
        open={ showCopyModal.show }
        toggle={ setShowCopyModal }
        copyCost={ copyCost }
      />
      <SummaryRow
        totalCost={ totalCost }
        totalPrice={ totalPrice }
        totalMargin={ totalMargin }
      />
      <TitleRow />
      <RowWrapper>
        {vendors.map((vendor, key) => (
          <InputRow
            id={ key.toString() }
            key={ key }
            vendor={ vendor }
            isEdit={ isEdit }
            isImplementing={ isImplementing }
            handleChangeInput={ handleChangeInput }
            handleChangeDate={ handleChangeDate }
            handleChangeSelect={ handleChangeSelect }
            setShowCopyModal={ setShowCopyModal }
            copyRow={ copyRow }
            deleteRow={ deleteRow }
          />
        ))}
      </RowWrapper>
      { isEdit && !isImplementing &&
        <AddButton onClick={ handleClickAdd }>
          <FiFilePlus style={ { fontSize: 16 } } />
          <AddText>Add a Cost</AddText>
        </AddButton>
      }
    </Root>
  )
})

const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

const RowWrapper = styled.div`
  height: 100%;
`

const AddButton = styled(Button)`
  width: 109px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #27AE60;
  border-radius: 4px;
  border: none;
  margin: 16px;
  padding: 0;

  svg {
    margin-right: 8px;
  }
`

const AddText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  line-height: 180%;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-cost-planning/tab-pane-other-service/index.js